import { tUnderConstruction } from './SL00000Sprint00'
import { holiday } from './SL20000Sprint01'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'

import { retrospectiveIntroduction, submissionPercentage } from './SLSprint00'
import { basicSlide, orderedListSlide, tPrework, tRecap, sprintDemosIntro, sprintDemos } from './SLSprint00'
import { demoAssignment } from './SLSprint00'
import { retrospectiveBreakout } from './SLSprint00'
import { checklistAnnouncementsPreworkAndAgenda, completeDeck, tLab } from './SL00000Sprint00'



import { list61200Sprint06 } from '../ActivityLists/AL61200Sprint06' 
// Software Architecture (SA) module 6 / sprint 6 global values.
const sprint = 6
const activityList = () => { return list61200Sprint06(sprint) }

const aa_6_1of1_PAaA = {
	'prework':[
		`All sprint ${sprint-1} activities and assignments due Sunday!`, '',
		`Be prepared for Sprint ${sprint-1} Demos and Retrospective`,
		`Be prepared for Sprint ${sprint} Planning, Discussion ${sprint}, and Lab` ],
	'announcements':[ 
		'Welcome back!', '',
		`Let’s stay focused on bringing closure to Sprint ${sprint-1} and completing Sprint ${sprint} Planning` ],
	'agenda':[
		`Sprint ${sprint-1} Demos and Retrospective`,
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		`Discussion Board ${sprint} as a Scrum Team`,
		'Lab',
		'Prework for Next Class',
		'Recap' ]
}

const sprint_xx_class_1 = (activityList, xyz_2_1of1_PAaA, xyz_3_1of1Prework) => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:12, submitted:11 },
			{ name: 'Quiz', due:12, submitted:11 },
			{ name: 'Lab', due:12, submitted:10 },
			{ name: 'Reflection', due:12, submitted:11}])
	}

	const retrospectiveInto = () => { return retrospectiveIntroduction(sprint)}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			'Excellent job getting everything submitted on time',
			`Thank you for your Reflection ${sprint-1} comments`,
			'Working with teams is challenging, can be enjoyable, and is essential',
			'... but mostly very challenging teammates, configuration management (Git, Azure, etc.), it’s hard',
			'Midterm and Friday off was a challenge' ])
	}

	const breakout = () =>{ return retrospectiveBreakout(sprint) }

	const sprintPlanning = () => {
		return orderedListSlide(`Sprint ${sprint} Planning`, `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'We will complete our scrum team Discussion Board breakout session today',
			`We will have sprint ${sprint} Demos and Retrospective next Monday` ])
		
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list and assignments together.' ]
		)
	}
	const shortBreak = () => {
		return basicSlide('Break', [
			'5 minute break.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review Sprint ${sprint} activity list & assignments in detail`,
			'Discuss and identify questions/concerns',
			'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns' ]
		)
	}
	const recap = () => { return tRecap(xyz_2_1of1_PAaA.agenda.slice(1))}

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(xyz_2_1of1_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', xyz_3_1of1Prework, sprint, activityList) }
	return completeDeck(slideDeck, [ sprintDemosIntro, sprintDemos, demoAssignment, retrospectiveInto, 
		metricsSubmissionPercentage, retrospective, breakout, shortBreak, sprintPlanning, activitiesReview, 
		planningBreakout, preworkNext, recap, tLab])
}


const aa_6_1of1 = () => { return sprint_xx_class_1(activityList, aa_6_1of1_PAaA, aa_6_1of1_PAaA.prework) }
//const aa_6_1of1 = () => { return [ tUnderConstruction, holiday, renderCalendar, renderFinalExamTimes ] }
const aa_6_2of1 = () => { return [ tUnderConstruction, holiday, renderCalendar, renderFinalExamTimes ] }

export const aa_6_slidedeck = [ aa_6_1of1, aa_6_2of1 ]